import { createFileRoute } from "@tanstack/react-router";
import { TenantRecordAccessPage } from "@/features/tenants/pages/tenant-record-page";
export const Route = createFileRoute("/_authed/tenant-records/$slug/access")({ component: TenantRecordAccessPage });
